import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useParams } from "react-router-dom";
import { toastr } from "react-redux-toastr";
import { push } from "../../utils/navigation";
import {
  resetPassword,
  getResetPasswordDetail,
  verifyEmailAddress,
} from "../../actions/userActions";
import _ from "lodash-es";
import LayoutNoSidebar from "../../Layouts/LayoutNoSidebar";
import Spinner from "../Common/Spinner";
import ForgotPasswordVerificationView from "./ForgotPasswordVerificationView";
import { requestHasError, trimWhiteSpaces } from "../../utils/lib";
import PasswordResetView from "./PasswordResetView";
import { BASE_URL } from "../../constants";
import { string } from "prop-types";

const ForgotPasswordView = (props) => {
  const {
    dispatch,
    resetPassword,
    getResetPasswordDetail,
    siteConfig,
    verifyEmailAddress,
  } = props;
  const { token } = useParams();
  const [pageLoading, setPageLoading] = useState(true);
  const [formData, setFormData] = useState({});
  const [saveLoading, setSaveLoading] = useState(false);
  const [hasToken, setHasToken] = useState(false);
  const [verificationRequestSubmitted, setVerificationRequestSubmitted] =
    useState(false);
  const [resetPasswordData, setResetPasswordData] = useState({
    expiredToken: false,
  });

  useEffect(() => {
    // Email verification is complete and user has accessed the url via link
    if (token) {
      setHasToken(true);
      setPageLoading(false);
      return getTokenDetails(token);
    }
    // Need to verify the email address.
    setPageLoading(false);
  }, []);

  const getTokenDetails = (token) => {
    dispatch(getResetPasswordDetail({ token })).then((x) => {
      if (!requestHasError({ x })) {
        return setResetPasswordData({ expiredToken: false, ...x.data });
      }
      setResetPasswordData({ expiredToken: true });
    });
  };

  const handleSave = () => {
    if (!formData.newPassword) return toastr.error("New password is required.");
    if (!formData.confirmNewPassword)
      return toastr.error("Confirm new password is required.");
    setSaveLoading(true);
    const payLoad = {
      ...formData, userName: resetPasswordData && resetPasswordData.userName, passwordResetToken: token,
      isExternalProvider: resetPasswordData && resetPasswordData.isExternalProvider
    };
    dispatch(resetPassword({ payLoad })).then((x) => {
      setSaveLoading(false);
      if (!requestHasError({ x })) {
        toastr.success("Password updated.");
        dispatch(push(`${BASE_URL}/callback`));
      }
    });
  };

  const handleEmailVerification = () => {
    if (!trimWhiteSpaces(formData && formData.emailAddress)) {
      return toastr.error("Email Address is required");
    }
    setSaveLoading(true);
    dispatch(verifyEmailAddress({payLoad: {emailAddress: trimWhiteSpaces(formData.emailAddress)}})).then(x => {
      setSaveLoading(false);
      if(!requestHasError({x})){
        setVerificationRequestSubmitted(true);
      }
    });
  };

  const handleFieldChange = ({ value, field }) => {
    setFormData({ ...formData, [field]: value.currentTarget.value });
  };
  return (
    <LayoutNoSidebar siteConfig={siteConfig}>
      {pageLoading ? (
        <Spinner />
      ) : token ? (
        <PasswordResetView
          handleFieldChange={handleFieldChange}
          resetPasswordData={resetPasswordData}
          saveLoading={saveLoading}
          handleSave={handleSave}
        />
      ) : (
        <ForgotPasswordVerificationView
          formData={formData}
          saveLoading={saveLoading}
          handleEmailVerification={handleEmailVerification}
          emailVerified={verificationRequestSubmitted}
          handleFieldChange={handleFieldChange}
        />
      )}
    </LayoutNoSidebar>
  );
};

function mapStateToProps(state) {
  return { siteConfig: state.apiConfig };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch,
    resetPassword,
    getResetPasswordDetail,
    verifyEmailAddress,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ForgotPasswordView);
